export default "__VITE_ASSET__DTxuMcAD__"